import React from 'react';
import { MdOutlineAdd, MdOutlineRemove } from 'react-icons/md';

const IncrementButton = ({ min, max, onChange, value }) => {
  return (
    <div
      className="w-32 h-10 rounded-full px-1 py-1
        flex flex-row bg-primary justify-between items-center"
    >
      <button
        type="button"
        className="rounded-full w-8 h-8 bg-white flex justify-center items-center"
        onClick={() => {
          const newValue = value - 1;
          if (min === undefined || min === null || newValue >= min) {
            onChange(newValue);
          }
        }}
      >
        <MdOutlineRemove className="text-primary text-2xl" />
      </button>
      <p className="font-primaryMedium text-base text-white">{value}</p>
      <button
        type="button"
        className="rounded-full w-8 h-8 bg-white flex justify-center items-center"
        onClick={() => {
          const newValue = value + 1;
          if (max === undefined || max === null || newValue <= max) {
            onChange(newValue);
          }
        }}
      >
        <MdOutlineAdd className="text-primary text-2xl" />
      </button>
    </div>
  );
};

export default IncrementButton;
